// extracted by css-extract-rspack-plugin
export default {"content":"sectionLoading_content__wDuFG"};